var $ = global.jQuery = global.$ = require('jquery');
var parser = require('./lib/parser');

var svg4everybody = require('./third-party/svg4everybody');

// require('picturefill');
require('modernizr');
require('jquery-placeholder');
require('./widgets/index');

var app = {
  init: function(){
    var self = this;
    parser.parse('body');
  }
};

app.init();

$(function(){
  svg4everybody();
  $('.rte table, .table').each(function(){
    if (!$(this).parents().eq(0).hasClass('table-overflow')) {
      $(this).wrap('<div class="table-overflow"></div>');
    }
  });
  $('input, textarea').placeholder();
});



//////////////////
// WEBPACK FOOTER
// ./source/scripts/app.js
// module id = 1
// module chunks = 0